import { useTranslation } from 'react-i18next'
import { useDebounceValue } from 'usehooks-ts'

import { useAnchorsStrategiesQuery } from '@/entities/anchor'

import NoData from '@/shared/components/placeholders/NoData'
import { Blanket } from '@/shared/components/ui/blanket'
import { Content, Layout } from '@/shared/components/ui/layout'
import { Loader } from '@/shared/components/ui/loader'
import { useLocationQuery } from '@/shared/hooks/useLocationQuery'

import StrategiesPageFooter from './StrategiesPageFooter'
import StrategiesPageHeader from './StrategiesPageHeader'
import StrategiesTable from './StrategiesTable/StrategiesTable'
import StrategiesTableToolbar from './StrategiesTable/StrategiesTableToolbar'

export function StrategiesPage() {
	const { t } = useTranslation()

	const [{ limit = 100, offset = 0, filters, search }] = useLocationQuery()
	const [searchTextDebounce] = useDebounceValue(search, 1000)
	const {
		data: anchorsStrategies,
		isFetching,
		isError,
	} = useAnchorsStrategiesQuery({
		filters,
		search: searchTextDebounce || '',
		limit,
		offset,
	})
	const data = anchorsStrategies?.data
	const hasNoData = !isFetching && !data?.length

	return (
		<Layout className='px-4' data-testid='anchoring-management-strategies-page'>
			<Blanket
				className='absolute flex flex-col items-center justify-center space-y-5 rounded-lg bg-transparent'
				isTinted={isFetching}
			>
				<div className='z-50 rounded-lg bg-white/50 p-5 shadow backdrop-blur-md fade-in dark:bg-black/50'>
					<Loader />
				</div>
			</Blanket>
			<Layout className='space-y-2 py-2'>
				<StrategiesPageHeader hasError={isError} />
				<StrategiesTableToolbar />
				<Content className='border-base overflow-hidden rounded-lg border border-solid text-xs'>
					{hasNoData && (
						<NoData
							className='flex-col p-10'
							title={t('anchoring_management.strategy_page.table.no_data')}
						/>
					)}
					{!!data?.length && <StrategiesTable data={data} />}
				</Content>
				<StrategiesPageFooter
					total={anchorsStrategies?.total || 0}
					isFetching={isFetching}
					totalOnPage={data?.length || 0}
				/>
			</Layout>
		</Layout>
	)
}
